import PrimeVue, { defaultOptions } from "primevue/config";
import type { App, Plugin } from "vue";
import ToastService from "primevue/toastservice";
import DialogService from "primevue/dialogservice";
import ConfirmationService from "primevue/confirmationservice";
import Tooltip from "primevue/tooltip";
import PrimeVueTheme from "@primeuix/themes/material";
import { definePreset } from "@primeuix/themes";
import { FocusTrap } from "primevue";
import { shadeVariants } from "@moroku/money-webapp-components";

const MoneyPreset = definePreset(PrimeVueTheme, {
  semantic: {
    primary: {
      ...shadeVariants.reduce((acc: Record<string, string>, shade) => {
        acc[`${shade}`] = `var(--color-primary-${shade}, var(--color-primary))`;
        return acc;
      }, {}),
    },
  },
});

export function installPrimeVue(app: App<Element>): App<Element> {
  app.use(PrimeVue as Plugin<unknown[]>, {
    theme: {
      preset: MoneyPreset,
      options: {
        // prefix: "p",
        darkModeSelector: ".money-dark", // not used
        cssLayer: {
          name: "primevue",
          order: "money-components-tailwind-base, primevue, money-components-tailwind-utilities, tailwind-utilities",
        },
      },
    },
    ripple: true,
    ...(defaultOptions.locale && {
      locale: {
        ...defaultOptions.locale,
        // PrimeVue uses the US date format by default, but our users will be from Australia.
        // `usePrimeVueLocale` will override this with the browser/os locale.
        dateFormat: "dd/mm/yy",
      },
    }),
  });

  app.use(ToastService);
  app.use(DialogService);
  app.use(ConfirmationService);
  app.directive("tooltip", Tooltip);
  app.directive("focustrap", FocusTrap);

  return app;
}
